import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { rates } from "../../rbac-consts";
import BaseRatesTabsContainer from "./admin/BaseRatesTabsContainer";

const BaseRatesWrapper = ({match}) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={rates.ADMIN}
      yes={() => (
        <BaseRatesTabsContainer match={match}/>
      )}
    />
  );
};

export default BaseRatesWrapper;